<template>
  <div id="model">
    <el-dialog
      title
      :visible.sync="dialogVisible"
      width="100%"
      :show-close="false"
      :close-on-click-modal="false"
    >
      <div class="model-content">
        <div class="img-box">
            <img src="@/assets/imgs/layout/item1.png" alt width="100%" class="img-content" />
        </div>
        <i class="model-close" @click="dialogVisible = false"></i>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: "Model",
  props: {
    showModel: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dialogVisible: this.showModel
    };
  },
  methods: {}
};
</script>

<style lang="less">
#model {
  .el-dialog {
    margin-top: 5vh;
    box-shadow:0 0 0 transparent !important;
    .el-dialog__header,
    .el-dialog__body,.el-dialog__footer {
      padding: 0;
    }
  }
  .el-dialog,
  .el-pager li {
    background: transparent;
  }
}
</style>
<style lang="less" scoped>
#model {
  .model-content {
    width: 100%;
    .img-box{
        width: 6rem;
        max-width: 300px;
        margin: 0 auto;
    }
    .model-close{
        height: .8rem;
        width: .8rem;
        display: block;
        margin: 0 auto;
        background: url("~@/assets/imgs/layout/model_close.png") no-repeat ;
        background-size:100% 100%;
        margin-top: 1.2rem;
    }
  }
}
</style>